$('body').ready(function() {
  // delivery country selection
  $('[data-delivery-country="United Kingdom"]').addClass('active');
  $('[data-delivery-country]').click(function(e) {
    const button = e.target.closest('button');
    if (!button) return;
    const country = button.dataset.deliveryCountry;
    $('[data-delivery-country]').removeClass('active'); 
    button.classList.add('active');
    $('[data-selected-delivery-country]').attr('data-selected-delivery-country', country).text(country).trigger('change');
    $('[data-selected-country-delivery-range]').addClass('hidden');
    $(`[data-selected-country-delivery-range="${country}"]`).removeClass('hidden');
  });
  //end delivery country selection

  //PDP trouser picker
  $('.dropdown-list-item').click(function() {
    const varianId = this.dataset.variantId;
    const productId = this.dataset.productId;
    $('variant-picker').attr('data-select-trouser-variant-id', varianId);
  });
  //end PDP trouser picker
  // CB fancybox
  Fancybox.bind("[data-fancybox]", {
    
  });
  // Cb end fancybox
  // CB video play btn
  $('.cb-video-play-button').click(function() {
    const thumbnail = $('[data-media-type="video"], [data-media-type="external_video"]');
    thumbnail.click();
  });
  // CB end video play btn
  // CB size chart country select
  $('button[data-sizes-for-country]').click(function(e){
    $('button[data-sizes-for-country]').removeClass('active');
    this.classList.add('active');
    const countrySelect = this.dataset.sizesForCountry;
    $('[data-sizes-for-country-content]').addClass('hidden');
    $(`[data-sizes-for-country-content="${countrySelect}"]`).removeClass('hidden');
    $('[data-measurement-units="in"]').each(function(){
      this.click();
    });
  });
  // CB end size chart country select
  // CB inches to cm convert
  $('button[data-measurement-units]').click(function(e) {
    const container = this.closest('[data-measurement-buttons-for]');
    container.querySelectorAll('button').forEach(el => el.classList.remove('active'));
    this.classList.add('active');
    const clickedUnits = this.dataset.measurementUnits;
    const unitsForTable = container.dataset.measurementButtonsFor;
    let $table = $(`[data-size-table="${unitsForTable}"]`);
    $table.find('[data-inches]').each(function(){
      const inches = this.dataset.inches;
      if (clickedUnits === 'cm'){
        if(inches.includes('-') || this.classList.contains('cb-round-ceil')){
          const cm = inches.split('-').map(val => Math.ceil(+val * 2.54)).join(' - ');
          this.textContent = cm;
        } else {
          const cm = +inches * 2.54;
          this.textContent = `${Number(cm.toFixed(1))}`;
        }
      } else if (clickedUnits === 'in'){
        this.textContent = inches;
      }
    });
  });
  // CB end inches to cm convert
  // CB product variant picker
  if ($('[data-size-label] input[checked]').length){
    const initialSelect = $('[data-size-label] input[checked]');
    const initialOptionValue = initialSelect.closest('[data-size-label]').attr('data-option-value');
    const initialShortOptionValue = initialSelect.closest('[data-size-label]').attr('data-short-option-value');
    let initalLabelText = initialShortOptionValue;
    if (initialOptionValue.toLowerCase() !== initialShortOptionValue.toLowerCase()){
        initalLabelText = initalLabelText + ' | ' + initialOptionValue;
      }
    $('[data-option-value-label]').text(initalLabelText);
  }
  $('variant-picker.cb-size-picker').change(function(e){
    const optionValue = e.target.closest('[data-size-label]')?.getAttribute('data-option-value');
    if (!optionValue) return;
    const shortOptionValue = e.target.closest('[data-size-label]').getAttribute('data-short-option-value');
    let labelText = shortOptionValue;
    if (optionValue.toLowerCase() !== shortOptionValue.toLowerCase()){
      labelText = labelText + ' | ' + optionValue;
    }
    $('[data-option-value-label]').text(labelText);
  });
  // CB end product variant picker
  //CB judge me widget modify (left hand title)
  const targetNode = document.querySelector('body.product-page main');
  if (targetNode) {
    let foundTitle = false;
    let foundSummary = false;
    let foundAverage = false;
    const reviewsObserver = new MutationObserver((mutationsList) => {
      var $titleEl = $('.jdgm-rev-widg:not([data-number-of-reviews="0"]) .jdgm-rev-widg__title');
      var $summaryEl = $('.jdgm-rev-widg:not([data-number-of-reviews="0"]) .jdgm-rev-widg__summary-text.jdgm-all-reviews__summary-text--verified');
      var $averageEl = $('.jdgm-rev-widg:not([data-number-of-reviews="0"]) .jdgm-rev-widg__summary-average');
      if ($titleEl.length && foundTitle === false){
        foundTitle = true;
        const text = $titleEl.text().split(' ')[1];
        var $title = $('<h3>').addClass('cb-jdgm-rev-widg__title').text(text);
        $titleEl.after($title);
        $titleEl.remove();
      }

      if ($summaryEl.length && foundSummary === false){
        foundSummary = true;
        const summaryText = $summaryEl.text().replace("Based on ", "");
        var $summary = $('<div>').addClass('jdgm-rev-widg__summary-text jdgm-all-reviews__summary-text--verified').text(summaryText);
        $summaryEl.after($summary);
        $summaryEl.remove();
      }

      if ($averageEl.length && foundAverage === false){
        foundAverage = true;
        const averageText = $averageEl.text().split(' ')[0];
        var $average = $('<span>').addClass('jdgm-rev-widg__summary-average').text(averageText);
        $averageEl.after($average);
        $averageEl.remove();
      }
    });
    
    const config = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    };
    reviewsObserver.observe(targetNode, config);
  }
  //CB end judge me widget modify (left hand title)
  // CB add date and country iso code to contact form input
  const contactFormNode = document.querySelector('.contact-form-wrapper');
  if (contactFormNode) {
    const contactFormObserver = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.matches('button.submit') || node.querySelector('button.submit')) {
                $('.contact-form-wrapper button.submit').click(function() {
                  const now = new Date();
                  const options = { 
                    year: 'numeric', 
                    month: 'long', 
                    day: 'numeric', 
                    hour: 'numeric', 
                    minute: '2-digit', 
                    hour12: true 
                  };
                  const formattedDate = now.toLocaleString('en-US', options);
                  $('.contact-form-wrapper .cb-contact-date input').val(formattedDate);
                  $('.contact-form-wrapper .cb-country-iso-code input').val(contactFormNode.dataset.countryIsoCode);
                });
              }
            }
          });
        }
      }
    });
    const contactFormObserverConfig = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    };
    contactFormObserver.observe(contactFormNode, contactFormObserverConfig);
  }
  // CB add date and country iso code to contact form input
  // CB US state detection
  fetch("https://ipapi.co/json/")
  .then(res => {
    if (res.ok && res.status === 200) { 
      return res.json() 
    } else throw new Error("Can't fetch IP API");
  })
  .then(data => {
    if (data.country_code_iso3 === 'USA') {
      $('[data-us-region-placeholder]').addClass('displayable').text(data.region + ", ");
    }  
  })
  .catch(error => console.error(error.message));
  // CB end US state detection
    // Update product price when select/unselect bundle item

  const calcBundlesSum = function() {
    if (!$('.cb-bundle .cb-input').length) return;
    let finalPrice = 0;
    $('.cb-bundle .cb-input:checked').each(function(index, el) {
      finalPrice += +el.dataset.price;
    });
    
    const formattedPrice = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(finalPrice / 100);

    const payIn3FormattedPrice = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(finalPrice / 100 / 3);

    const finalFormatedPrice = $('.cb-bundle .cb-input').data('currency').replace('moneyValue', formattedPrice);
    const payIn3FinalFormatedPrice = $('.cb-bundle .cb-input').data('currency').replace('moneyValue', payIn3FormattedPrice);
    
    $('.product-info .product-price .regular-price').text(finalFormatedPrice);
    $('.product-info .product-price .cb-pay-in-3-price').text(payIn3FinalFormatedPrice);
  }
  calcBundlesSum();
  $('.cb-bundle .cb-input').on('change', function(){
    calcBundlesSum();
  });
  // end Update product price when select/unselect bundle item
  // bundle items size change start
  $('.cb-bundle .dropdown-list-item').on('click', function(){
    const optioValueId = $(this).data('option-value-id');
    const shortOptionValue = $(this).find('.cb-short-option-value').text();
    var $span = `<span class="cb-dropdown-activator-short-option-value">${shortOptionValue}</span>`;
    $(this).closest('variant-picker').find('button[data-dropdown-activator]').prepend($span);
    calcBundlesSum();
  });
  // bundle items size change end

  // Announcement bar: aria-hidden (WCAG)
  document.querySelectorAll('announcement-bar').forEach(function(bar) {
    bar.querySelectorAll('.announcement').forEach(function(el) {
      new MutationObserver(function() {
        el.setAttribute('aria-hidden', el.classList.contains('is-active') ? 'false' : 'true');
      }).observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  });
  // End announcement bar aria-hidden
});

// Kiwi size chart: aria-label (WCAG)
(function labelKiwiInputs() {
  document.querySelectorAll('.ks-calculator-element.input-element').forEach(function(el) {
    var labelEl = el.querySelector('.element-label label');
    if (!labelEl) return;
    var labelText = labelEl.textContent.trim();
    if (!labelText) return;
    el.querySelectorAll('input, select').forEach(function(inp) {
      if (!inp.getAttribute('aria-label') && !inp.getAttribute('aria-labelledby') && !inp.closest('label')) {
        inp.setAttribute('aria-label', labelText);
      }
    });
  });
}());
window.addEventListener('load', function() {
  (function labelKiwiInputs() {
    document.querySelectorAll('.ks-calculator-element.input-element').forEach(function(el) {
      var labelEl = el.querySelector('.element-label label');
      if (!labelEl) return;
      var labelText = labelEl.textContent.trim();
      if (!labelText) return;
      el.querySelectorAll('input, select').forEach(function(inp) {
        if (!inp.getAttribute('aria-label') && !inp.getAttribute('aria-labelledby') && !inp.closest('label')) {
          inp.setAttribute('aria-label', labelText);
        }
      });
    });
  }());
  new MutationObserver(function() {
    document.querySelectorAll('.ks-calculator-element.input-element').forEach(function(el) {
      var labelEl = el.querySelector('.element-label label');
      if (!labelEl) return;
      var labelText = labelEl.textContent.trim();
      if (!labelText) return;
      el.querySelectorAll('input:not([aria-label]), select:not([aria-label])').forEach(function(inp) {
        if (!inp.getAttribute('aria-labelledby') && !inp.closest('label')) {
          inp.setAttribute('aria-label', labelText);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
});
// End Kiwi size chart labels
// ==== Gift card recipient — "Email it to someone" (skins native <recipient-form>) ====
(function () {
  "use strict";

  var MAX_DAYS = 90;
  var MAX_MESSAGE = 200;

  var FLAG = 'properties[__shopify_send_gift_card_to_recipient]';
  var OFFSET = 'properties[__shopify_offset]';
  var NAMES = {
    email: 'properties[Recipient email]',
    name: 'properties[Recipient name]',
    message: 'properties[Message]',
    sendOn: 'properties[Send on]'
  };

  var SUBTITLE = "We'll email it directly to the recipient.";
  var DATE_HINT = "Leave empty to send it straight away. Up to 90 days ahead.";

  var ENVELOPE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<rect x="2.75" y="5" width="18.5" height="14" rx="2"/>' +
    '<path d="m3.5 6.5 8.5 6 8.5-6"/></svg>';

  function el(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html != null) node.innerHTML = html;
    return node;
  }

  function field(form, key) {
    return form.querySelector('[name="' + NAMES[key] + '"]');
  }

  function isoLocal(date) {
    var m = date.getMonth() + 1;
    var d = date.getDate();
    return date.getFullYear() + "-" + (m < 10 ? "0" : "") + m + "-" + (d < 10 ? "0" : "") + d;
  }

  function commonAncestor(nodes) {
    var ancestor = nodes[0];
    for (var i = 1; i < nodes.length && ancestor; i++) {
      while (ancestor && !ancestor.contains(nodes[i])) ancestor = ancestor.parentElement;
    }
    return ancestor;
  }

  function dateFormatHint() {
    try {
      var parts = new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).formatToParts(new Date());
      var out = "";
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        out += p.type === "day" ? "DD" : p.type === "month" ? "MM" : p.type === "year" ? "YYYY" : p.value;
      }
      return out;
    } catch (e) {
      return "DD/MM/YYYY";
    }
  }

  function blockOf(node, container) {
    var current = node;
    while (current && current.parentElement && current.parentElement !== container) {
      current = current.parentElement;
    }
    return current && current.parentElement === container ? current : null;
  }

  function labelFor(form, checkbox) {
    var wrapping = checkbox.closest("label");
    if (wrapping && form.contains(wrapping)) return wrapping;
    if (checkbox.id) {
      var labels = form.querySelectorAll("label");
      for (var i = 0; i < labels.length; i++) {
        if (labels[i].htmlFor === checkbox.id) return labels[i];
      }
    }
    return null;
  }

  function setup(form) {
    if (form.hasAttribute("data-gcr-ready")) return;

    var checkbox = form.querySelector('input[type="checkbox"][name="' + FLAG + '"]');
    if (!checkbox) return;

    var present = [];
    for (var key in NAMES) {
      var node = field(form, key);
      if (node) present.push(node);
    }
    if (!present.length) return;

    var offset = form.querySelector('[name="' + OFFSET + '"]');

    var managed = present.slice();
    if (offset) managed.push(offset);

    var fields = commonAncestor(present);

    if (!fields || fields === form || !form.contains(fields)) return;

    form.setAttribute("data-gcr-ready", "");
    form.classList.add("gcr");
    fields.setAttribute("data-gcr-fields", "");

    var head = labelFor(form, checkbox);
    if (head) {
      head.setAttribute("data-gcr-head", "");

      var title = el("span", "gcr__title");
      while (head.firstChild) title.appendChild(head.firstChild);

      var copy = el("span", "gcr__header-copy");
      copy.appendChild(title);
      var sub = el("span", "gcr__sub");
      sub.textContent = SUBTITLE;
      copy.appendChild(sub);

      var left = el("span", "gcr__header-left", '<span class="gcr__tile">' + ENVELOPE + "</span>");
      left.appendChild(copy);

      head.appendChild(left);
      head.appendChild(el("span", "gcr__header-right", '<span class="gcr__switch"></span>'));
    }

    var labels = fields.querySelectorAll("label");
    for (var li = 0; li < labels.length; li++) {
      if (!labels[li].textContent.trim() && !labels[li].querySelector("input, textarea, select")) {
        labels[li].classList.add("gcr__blank");
      }
    }

    var message = field(form, "message");
    if (message) {
      if (!message.getAttribute("maxlength")) {
        message.setAttribute("maxlength", String(MAX_MESSAGE));
      }
      var counter = el("span", "gcr__count");
      var messageBlock = blockOf(message, fields);
      if (messageBlock) messageBlock.appendChild(counter);
      else message.insertAdjacentElement("afterend", counter);

      var tally = function () {
        var length = message.value.length;
        counter.textContent = length + "/" + MAX_MESSAGE;
        counter.classList.toggle("gcr__count--over", length > MAX_MESSAGE);
      };
      message.addEventListener("input", tally);
      tally();
    }

    var sendOn = field(form, "sendOn");
    if (sendOn) {
      var today = new Date();

      var last = new Date(today.getFullYear(), today.getMonth(), today.getDate() + MAX_DAYS);
      sendOn.min = isoLocal(today);
      sendOn.max = isoLocal(last);

      var format = null;
      var host = sendOn.parentElement;
      if (host && host !== fields) {
        format = el("span", "gcr__dateformat");
        format.textContent = dateFormatHint();
        var cs = window.getComputedStyle(sendOn);
        format.style.paddingTop = cs.paddingTop;
        format.style.paddingRight = cs.paddingRight;
        format.style.paddingBottom = cs.paddingBottom;
        format.style.paddingLeft = cs.paddingLeft;
        format.style.fontSize = cs.fontSize;
        format.style.fontFamily = cs.fontFamily;
        format.style.letterSpacing = cs.letterSpacing;
        if (window.getComputedStyle(host).position === "static") host.style.position = "relative";
        host.appendChild(format);
      }

      var markEmpty = function () {
        var empty = !sendOn.value;
        sendOn.classList.toggle("gcr__date--empty", empty);
        if (format) format.classList.toggle("gcr__dateformat--off", !empty);
      };
      sendOn.addEventListener("input", markEmpty);
      sendOn.addEventListener("change", markEmpty);
      markEmpty();

      if (!form.querySelector(".gcr__hint")) {
        var hint = el("span", "gcr__hint");
        hint.textContent = DATE_HINT;
        var dateBlock = blockOf(sendOn, fields);
        if (dateBlock) dateBlock.appendChild(hint);
        else sendOn.insertAdjacentElement("afterend", hint);
      }
    }

    var productForm = form.closest('form[action*="/cart/add"]');
    var hidden = [];

    function toggleDynamicCheckout(on) {
      var i;
      if (on) {
        if (!productForm) return;
        var buttons = productForm.querySelectorAll(
          '.shopify-payment-button, [data-shopify="payment-button"]'
        );
        for (i = 0; i < buttons.length; i++) {
          if (!buttons[i].hidden) {
            buttons[i].hidden = true;
            hidden.push(buttons[i]);
          }
        }
      } else {
        for (i = 0; i < hidden.length; i++) hidden[i].hidden = false;
        hidden.length = 0;
      }
    }

    function sync() {
      var on = checkbox.checked;
      form.classList.toggle("gcr--open", on);
      for (var i = 0; i < managed.length; i++) managed[i].disabled = !on;
      if (on && offset) offset.value = String(new Date().getTimezoneOffset());
      toggleDynamicCheckout(on);
    }

    checkbox.addEventListener("change", sync);
    sync();
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = scope.querySelectorAll("recipient-form");
    for (var i = 0; i < forms.length; i++) setup(forms[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
  document.addEventListener("shopify:block:select", function (event) {
    init(event.target);
  });
})();
// ==== end Gift card recipient ====
